// src/pages/UnderConstruction.tsx
import {
  Button,
  Center,
  Container,
  Stack,
  Title,
  useMantineColorScheme,
} from "@mantine/core";
import { IconHammer } from "@tabler/icons-react";

export function UnderConstruction() {
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Container size="md" py="xl">
      <Center>
        <Stack align="center" gap="md">
          <Title order={2}>🚧 Under Construction</Title>

          <Button
            variant="light"
            leftSection={<IconHammer size={18} />}
            component="a"
            href="/"
          >
            Return to Home
          </Button>
        </Stack>
      </Center>
    </Container>
  );
}
